<template lang="pug">
#lista-area-monitorada
    .reorganizarMapaTabela
        | {{ $t('mensagens.monitoramentoAgricola.reorganizarMapaTabela') }}
        span.reorganizarMapaTabela--reorganizar-icon(
            @click='organizarLayout',
            :class='[larguraTotal ? "rotate" : ""]'
        )
            i.lyra-icon.lyra-pontos

    .lista-area-monitorada__container(
        :class='[larguraTotal ? "isOrganizarWidth" : ""]'
    )
        .lista-area-monitorada__tabela
            h3 {{ $t('mensagens.monitoramentoAgricola.listagemTerritoriosEmMonitoramento') }}
                 BaseButton.mr-3(
                     v-if='isParaguai'
                     style='font-weight: bold',
                     type='text',
                     icon='el-icon-download',
                     @click='cadastrarSolicitacao(false)'
                 ) {{ $t('mensagens.comuns.monitoramento.exportarMonitoramentos') }}
                 el-dropdown(
                     v-else
                     trigger="click"
                     @command="exportDropdownSelect"
                     @visible-change="dropdownAberto = $event"
                     class="mr-3"
                 )
                     BaseButton(
                         style="font-weight: bold"
                         type="text"
                     )
                         i(class="mr-1" :class="dropdownAberto ? 'mdi mdi-file-document-minus-outline' : 'mdi mdi-file-document-plus-outline'" )
                         | {{ $t('mensagens.comuns.monitoramento.exportar') }}
                     el-dropdown-menu(slot="dropdown" class="exportar-monitoramento-dropdown")
                         el-dropdown-item(command="partial" class="exportar-monitoramento-dropdown-item")
                             span.item-text
                                 i.mdi.mdi-file-document-outline
                                 | {{ $t('mensagens.comuns.monitoramento.exportarMonitoramentosSimplificado') }}
                         el-dropdown-item(command="complete" class="exportar-monitoramento-dropdown-item")
                             span.item-text
                                 i.mdi.mdi-file-document-multiple-outline
                                 | {{ $t('mensagens.comuns.monitoramento.exportarMonitoramentosCompleto') }}
            .tabela
                TabelaListarTerritorioMonitoramento(
                    v-if='paginaAreasMonitoradas !== {}',
                    v-loading='carregandoGrid',
                    :paginaAreasMonitoradas='paginaAreasMonitoradas',
                    :paginacao='paginacao',
                    :larguraTotal='larguraTotal',
                    :key='keyLista',
                    @ordenar='ordenar',
                    @mudarPagina='mudarPagina'
                )

        .lista-area-monitorada__mapa
            mapa(
                v-loading='carregandoMapa'
                height='100%',
                idMapa='MapaListagemMonitoramentoSocioambiental',
                :key='keyMapa',
                :mapLayersConfigs='camadasMapa',
                :mapConfig='configuracoesMapa',
                :atualizarMapa='true'
            )
</template>
    
<script>
import L from 'leaflet';
import Mapa from '@/components/mapaLeafletClusters';
import TabelaListarTerritorioMonitoramento from '@/components/monitoramento/TabelaListarTerritorioMonitoramento';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import FileGenerationUtils from '@/utils/FileGenerationUtils';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';
import TerritorioService from '@/services/TerritorioService';
import {mapGetters, mapState} from 'vuex';
import constantes from '@/utils/constantes';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

const ICONE_PONTO_MAPA = L.icon({
    iconUrl: 'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
    iconSize: [18, 26]
});

export default {
    name: 'ListaAreaMonitoradaSocioambiental',

    components: {
        Mapa,
        TabelaListarTerritorioMonitoramento,
        BaseButton
    },

    props: {
        filtros: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['emProcessamentoDownloadMonitoramentoSocioAmbiental', 'emProcessamentoDownloadMonitoramentoSocioAmbientalCompleto']),
        isParaguai() {
            return this.usuarioLogado.paisGrupo === AmbientesEmpresas.PARAGUAY;
        }
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: false,
                    camadasControl: true,
                    fullscreen: true,
                    uploadFileControl: false,
                    marcarPontoControl: false,
                    botaoAnotacoes: false,
                    buscarAreaPorCoordenadasControl: false,
                    ferramentasControl: false,
                    buscarCarControl: true
                }
            },
            territorios: [],
            territoriosBuffer: [],
            larguraTotal: false,
            keyMapa: 1,
            keyLista: 10,
            paginaAreasMonitoradas: {},
            paginacao: {
                tamanho: constantes.TAMANHO_PAGINA,
                pagina: 0,
                ordenacao: 't.nome'
            },
            carregandoGrid: true,
            carregandoMapa: true,
            dropdownAberto: false
        };
    },

    watch: {
        filtros() {
            this.paginacao.pagina = 0;
            this.filtrarAreasMonitoradas();
        }
    },

    async created() {
        if (!this.$route.params.periodoAlertaSocioambiental) {
            await this.filtrarAreasMonitoradas();
        }
        if (this.usuarioLogado.paisGrupo !== AmbientesEmpresas.BRASIL) {
            this.configuracoesMapa.controls.buscarCarControl = false;
        }
    },

    async mounted() {
        this.idMunicipio = this.$route.params.idMunicipio;
        if (this.idMunicipio) {
            await this.mostrarMunicipio(this.idMunicipio);
        }
    },

    methods: {
        organizarLayout: function () {
            this.keyMapa++;
            this.keyLista++;
            this.larguraTotal = !this.larguraTotal;
        },

        async carregarMapaTerritorios() {
            try {
                this.carregandoMapa = true;
                const { data } = await TerritorioService.findByMapaMonitoramentoSocio(this.filtros);
                this.territorios = data;
                this.territoriosBuffer = data;
                this.mostrarTerritorios();
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível exibir os marcadores no mapa.'
                });
            } finally {
                this.carregandoMapa = false;
            }
        },

        mostrarTerritorios() {
            this.camadasMapa = [];

            this.territorios.forEach(({ id, centroide, ...informacoes }) => {
                let geoJson = centroide;
                if (typeof centroide === 'string') {
                    geoJson = JSON.parse(geoJson);
                }

                this.camadasMapa.push({
                    name: 'centroid' + id,
                    geoJson,
                    icon: ICONE_PONTO_MAPA,
                    popup: this.criarPopup({
                        id,
                        ...informacoes
                    })
                });
            });
        },

        async carregarGridAreaMonitorada() {
            try {
                this.carregandoGrid = true;
                const { data } =
                    await AreasMonitoradasService.buscarAreasMonitoradasSocioambiental(
                        this.filtros,
                        this.paginacao
                    );

                this.paginaAreasMonitoradas = data;

                this.camadaCentralizadaNome = null;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.filtrarAreasMonitoradas')
                });
            } finally {
                this.carregandoGrid = false;
            }
        },

        async filtrarAreasMonitoradas() {
            this.carregarMapaTerritorios();

            this.carregarGridAreaMonitorada();
        },

        ordenar(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.carregarGridAreaMonitorada();
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.carregarGridAreaMonitorada();
        },

        criarPopup({id, nome, nivel2Nome, nivel1Sigla }) {
            return `
                <h3>Território:</h3>
                <h4>${nome}</h4>
                <br>
                <h3>Localidade:</h3>
                <h4>${nivel2Nome} - ${nivel1Sigla}</h4>
                <br>
                <div id="btnVisualizar" class="btn-visualizar" onclick="window.location.replace('#/monitoramento/socioambiental/${id}', '_blank'); window.location.reload()">
                    <span>Visualizar</span>
                </div>
                <style>
                    #btnVisualizar {
                        background-color: var(--primary);
                        border-color: var(--primary);
                        color: var(--white);
                    }

                    #btnVisualizar:hover,
                    #btnVisualizar:focus {
                        background-color: var(--secondary);
                        border-color: var(--secondary);
                        color: var(--color-button-hover);
                        outline: 0px auto var(--secondary);
                    }
                </style>
            `;
        },

        cadastrarSolicitacao(isDetalhada) {
            let tipoArquivo = isDetalhada ? 'PLANILHA_MONITORAMENTO_SOCIOAMBIENTAL_DETALHADA' : 'PLANILHA_MONITORAMENTO_SOCIOAMBIENTAL_SIMPLES';
            FileGenerationUtils.cadastrarArquivoFilaProcessamento(this, tipoArquivo);
        },

        exportDropdownSelect(command) {
            let isDetalhada = command === 'complete';
            this.cadastrarSolicitacao(isDetalhada);
        }
    }
};
</script>

<style lang="scss" scoped>
#lista-area-monitorada {
    .reorganizarMapaTabela {
        font-size: 16px;
        margin-bottom: 16px;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .reorganizarMapaTabela--reorganizar-icon {
            padding: 10px;
            padding-bottom: 3px;
            background: var(--white);
            box-shadow: 0px 1px 7px 0px var(--block-shadow);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            cursor: pointer;

            i::before {
                width: 7px !important;
                height: 23px !important;
                background: #3b3b3b;
            }
            &.rotate {
                i::before {
                    transform: rotate(90deg);
                }
            }
        }
    }
    .lista-area-monitorada__container {
        display: flex;
        flex-wrap: wrap;
        height: calc(100vh - 255px);
        .lista-area-monitorada__tabela {
            width: 59%;

            .tabela {
                padding-top: 0px;
                padding-bottom: 10px;
                margin-right: 10px;
                width: calc(100% - 10px);
            }
        }
        .lista-area-monitorada__mapa {
            width: 41%;
            height: 633px;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 1px 5px 0px var(--block-shadow);
            margin-bottom: 14px;
            #mapa-listagem-territorio {
                border-radius: 6px;
            }
        }

        &.isOrganizarWidth {
            .lista-area-monitorada__tabela,
            .lista-area-monitorada__mapa {
                width: 100% !important;
            }
            .lista-area-monitorada__mapa {
                order: 1;
            }
            .lista-area-monitorada__tabela {
                order: 2;
                h3 {
                    margin-top: 12px !important;
                }
                .tabela {
                    margin-right: 0px !important;
                }
            }
        }
    }
    h3 {
        margin-top: -40px;
        color: var(--var(--black));
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }
    .dimensao-mapa {
        height: 100% !important;
    }
}
</style>
<style lang="scss">
.exportar-monitoramento-dropdown{
    padding: 15px !important;
}

.exportar-monitoramento-dropdown-item .item-text{
    font-weight: bold !important;
    color: var(--primary) !important;
}
</style>
